// Hook odpowiedzialny za pobranie typów zwrotów i reklamacji

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  ISearchRequest
} from 'api/types';

export interface IReturnsComplaintTypes {
  id: number,
  name: string,
  symbol: string
}

// parametry requestu do api
export type IRequest = IPaginationRequest & ISearchRequest;

// typ zwracanych danych
type IResponse = IPaginationResponse<IReturnsComplaintTypes>;

const getReturnsComplaintTypes = (params?: IRequest): Promise<IResponse> => axios.get('/return-complain/types', { params });

export const useGetReturnsComplaintTypes = (params?: IRequest, options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['types', params], () => getReturnsComplaintTypes(params), options)
